module.exports = __webpack_public_path__ + "img/soliq-xizmatlari.58fd3ec8.png";